import { Injectable } from '@angular/core';
import { FlyoutAccountSummaryHeader } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  DashboardResponse,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

import {
  getMemberDescriptionMessage,
  getTrackerStaticText,
  getWelcomeMessage,
  isDelta
} from '../../utils/account-summary-header/flyout-account-summary-header.utils';

@Injectable({
  providedIn: 'root'
})
export class FlyoutAccountSummaryHeaderAdapterService {
  getContent(
    response: DashboardResponse,
    headerFooterJson: HeaderFooterMachCore
  ): FlyoutAccountSummaryHeader {
    return {
      skyMilesNumber: response.smNumber,
      firstName: response.firstName,
      skymilesBalance: response.smBalance,
      membershipLevel: response.membershipLevel,
      greetingMessage: getWelcomeMessage(headerFooterJson, true),
      memberDescriptionMessage: getMemberDescriptionMessage(
        response,
        headerFooterJson
      ),
      millionMilerTier: response.millionMilerTier,
      is360Tier: response.is360Tier,
      millionMiler: response.millionMiler,
      skyPriority: response.skyPriority,
      isDelta: isDelta(headerFooterJson),
      labels: getTrackerStaticText(headerFooterJson)
    };
  }
}
